import axios from 'axios';

const api = axios.create({
  // Local dev (npm run serve) falls back to the local Laravel server;
  // production builds set VUE_APP_API_BASE_URL via .env.production so the
  // built bundle never ships pointing at a developer's own machine.
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8001/api',
  headers: {
    'Content-Type': 'application/json',
    // Without this, Laravel's validator treats every request as a
    // traditional web form and responds to a validation failure with a 302
    // redirect (HTML) instead of a 422 JSON error — every catch block in the
    // app that reads err.response.data.message then gets undefined and
    // falls back to a generic "something went wrong" toast, hiding the real
    // reason. Confirmed directly: POSTing /orders/create with a blank
    // billing field returned a 302 redirect without this header, and a
    // proper 422 with the real validation message once it was added.
    'Accept': 'application/json',
  }
});



export default api;
